import { render, staticRenderFns } from "./ProfileNavigation.vue?vue&type=template&id=a2a25e08&scoped=true"
import script from "./ProfileNavigation.vue?vue&type=script&lang=js"
export * from "./ProfileNavigation.vue?vue&type=script&lang=js"
import style0 from "./ProfileNavigation.vue?vue&type=style&index=0&id=a2a25e08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a25e08",
  null
  
)

export default component.exports